import { DiGraph } from "../../graph/digraph.js";

/**
 * High-level learning concepts (node ids) and “builds on” links for curriculum + PageRank.
 * DAG by construction — safe for `topologicalOrder`.
 */
const EDGES: readonly [string, string][] = [
  ["foundations", "trust_reasoning"],
  ["foundations", "privacy"],
  ["foundations", "prompting"],
  ["prompting", "context"],
  ["context", "system_safety"],
  ["context", "evidence"],
  ["trust_reasoning", "evidence"],
  ["evidence", "adversarial"],
  ["privacy", "adversarial"],
  ["system_safety", "tools_agents"],
  ["tools_agents", "retrieval"],
  ["retrieval", "model_theory"],
  ["adversarial", "research_frontier"],
  ["model_theory", "research_frontier"],
  // C.1 — 2026-04-25 — three new nodes (bias_ethics, deepfakes_scams,
  // verification_workflow) close gaps flagged by UNESCO AI Competency
  // Framework (Jan 2026), OECD/EC AILit (2026), and OWASP LLM Top-10 (2026).
  ["foundations", "bias_ethics"],
  ["evidence", "bias_ethics"],
  ["prompting", "verification_workflow"],
  ["evidence", "verification_workflow"],
  ["adversarial", "deepfakes_scams"],
  ["deepfakes_scams", "research_frontier"],
];

export const CURRICULUM_NODE_IDS: readonly string[] = [
  "foundations",
  "trust_reasoning",
  "privacy",
  "prompting",
  "context",
  "evidence",
  "system_safety",
  "tools_agents",
  "retrieval",
  "adversarial",
  "model_theory",
  "research_frontier",
  "bias_ethics",
  "deepfakes_scams",
  "verification_workflow",
];

export function buildCurriculumGraph(): DiGraph {
  const g = new DiGraph();
  for (const [a, b] of EDGES) {
    g.addEdge(a, b, 1);
  }
  for (const id of CURRICULUM_NODE_IDS) {
    g.addNode(id);
  }
  return g;
}
